import { InjectionToken } from '@angular/core';
import { FormState } from './forms/forms.reducer';
import {
  TableState,
  ICellTemplatesComponent,
} from './tables/table-definition';
import { getRoleFilteredNavigationConfig } from './layout/selectors/navigation.selectors';
import {
  IWithIdentifier,
  DxDocument,
  Navigation,
} from '@digitaix/types';
import { Observable } from 'rxjs';
import { FormGroupState } from 'ngrx-forms';
import { MemoizedSelector } from '@ngrx/store';

export const FORM_COMPONENT_TOKEN = new InjectionToken('form-component-token', {
  factory: () => null,
  providedIn: 'root'
});

export const FORM_REGISTER_TOKEN = new InjectionToken<
  Partial<FormState<any, any>>
>('form-register-token', {
  factory: () => null,
  providedIn: 'root'
});

export const TABLE_REGISTER_TOKEN = new InjectionToken<
  Partial<TableState<any>>
>('table-register-token', {
  factory: () => null,
  providedIn: 'root'
});

export const TABLE_ID_TOKEN = new InjectionToken<string>('table-id-token', {
  factory: () => null,
  providedIn: 'root'
});

export const ROW_ID_TOKEN = new InjectionToken<string>('row-id-token', {
  factory: () => null,
  providedIn: 'root'
});

/**
 * @deprecated use DX_FORM_ID
 */
export const FORM_ID_TOKEN = new InjectionToken<string>('@digitaix/core/FORM_ID_TOKEN', {
  factory: () => null,
  providedIn: 'root'
});

export interface ExpandedRowContext<R extends IWithIdentifier> {
  tableId: string;
  row: R;
  formId?: string;
  collectionPath: string;
}

export type DefaultTableQueryFunction = <D extends DxDocument, Query>(
  tableState: TableState<D>,
  parentQuery: Query | null
) => Query;
export const EXPANDED_ROW_CONTEXT = new InjectionToken<
  ExpandedRowContext<IWithIdentifier>
>('expanded-row-context');

export interface FormContainerContext<R extends IWithIdentifier> {
  formId: string;
  tableId?: string;
  row?: R;
  formGroupState$: Observable<FormGroupState<any>>;
}

export const FORM_CONTAINER_CONTEXT = new InjectionToken<
  FormContainerContext<IWithIdentifier>
>('form-container-context');

export const HEADBAR_COMPONENT_TOKEN = new InjectionToken(
  'headbar-component-token',
  {
    providedIn: 'root',
    factory: () => null
  }
);

export const CELL_TEMPLATE_COMPONENT = new InjectionToken<
  new () => ICellTemplatesComponent<any>
>('cell template component', {
  providedIn: 'root',
  factory: () => null
});

export const ALL_COLLECTION_IDS_TOKEN = new InjectionToken<string[]>(
  'all collection ids token',
  {
    providedIn: 'root',
    factory: () => []
  }
);

export const GLOBAL_COLLECTION_IDS = new InjectionToken<string[]>(
  'global collection ids',
  {
    providedIn: 'root',
    factory: () => []
  }
);

export const NOT_FOUND_404_ROUTE = new InjectionToken<string[]>(
  'not found 4040 route',
  {
    providedIn: 'root',
    factory: () => ['/', 'error', '404']
  }
);

export const INTERNAL_ERROR_500_ROUTE = new InjectionToken<string[]>(
  'not found 4040 route',
  {
    providedIn: 'root',
    factory: () => ['/', 'error', '500']
  }
);

export const DEFAULT_TABLE_QUERY = new InjectionToken<DefaultTableQueryFunction | null>(
  'default table query',
  {
    providedIn: 'root',
    factory: () => null
  }
);

export const NAVIGATION_CONFIG_SELECTOR: InjectionToken<MemoizedSelector<any, Navigation>> = new InjectionToken(
  'navigation config selector',
  {
    providedIn: 'root',
    factory: () => getRoleFilteredNavigationConfig
  }
);

export const NOOP = new InjectionToken('noop', {
  providedIn: 'root',
  factory: () => null
});

export const USE_APP_NAME_AS_TITLE = new InjectionToken<boolean>('@digitaix/core/USE_APP_NAME_AS_TITLE', {
  providedIn: 'root',
  factory: () => true,
});

export const TABLE_LOAD_DEBOUNCE_TIME = new InjectionToken('@digitaix/core/tables/TABLE_LOAD_DEBOUNCE_TIME', {
  providedIn: 'root',
  factory: () => 150,
});


export const PREFER_WINDOW = new InjectionToken('@digitaix/core/PREFER_WINDOW', {
  providedIn: 'root',
  factory: () => false,
});

export const DX_DOCUMENT_ID_TOKEN = new InjectionToken('@digitaix/core/DX_DOCUMENT_ID_TOKEN', {
  providedIn: 'root',
  factory:    () => null,
});

export const DX_DOCUMENT_TOKEN = new InjectionToken('@digitaix/core/DX_DOCUMENT_TOKEN', {
  providedIn: 'root',
  factory:    () => null,
});
